module.exports = __webpack_public_path__ + "images/info@1x.png?84086234";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info@1x.png
// module id = 672
// module chunks = 7